import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import { IconNames } from '@/components/UI/Types';
import styles from './RulesItem.module.scss';
import Typography from '@/components/UI/typography/Typography';
interface RulesItemTypes {
  icon: IconNames;
  title: string;
  description?: string;
  boldDescription?: string;
  forbiddenIcon?: boolean;
  roundedBorder?: boolean;
}
const RulesItem: FC<RulesItemTypes> = ({
  icon,
  title,
  description,
  boldDescription,
  forbiddenIcon,
  roundedBorder = false
}) => {
  return <Box className={`${styles['rules-item-content']} ${roundedBorder ? styles.rounded : ''}`} data-sentry-element="Box" data-sentry-component="RulesItem" data-sentry-source-file="RulesItem.tsx">
      <Box className={styles['header-rules-item']} data-sentry-element="Box" data-sentry-source-file="RulesItem.tsx">
        <Box className={forbiddenIcon ? styles['forbidden-icon'] : ''} data-sentry-element="Box" data-sentry-source-file="RulesItem.tsx">
          <Icon name={icon} type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="RulesItem.tsx" />
        </Box>
        <Typography variant="bodyM" color={'neutral_800'} data-sentry-element="Typography" data-sentry-source-file="RulesItem.tsx">
          {title}
        </Typography>
      </Box>
      <Box className={styles['description-rules-item']} data-sentry-element="Box" data-sentry-source-file="RulesItem.tsx">
        {boldDescription && <Typography variant="bodyM" color={'neutral_800'} className={styles['bold-description-rules-item']}>
            {boldDescription}
          </Typography>}
        <Typography variant="bodyM" color={'neutral_800'} className={styles['description-rules-text']} data-sentry-element="Typography" data-sentry-source-file="RulesItem.tsx">
          {description}
        </Typography>
      </Box>
    </Box>;
};
export default RulesItem;